import { RmaIcons } from '@rma/generic/ui/icon';

export const CALLOUT_CONFIG = {
  info: {
    backgroundStyle: 'bg-notification-10',
    icon: 'info',
    iconColor: 'text-notification-50',
  },
  success: {
    backgroundStyle: 'bg-success-10',
    icon: 'check',
    iconColor: 'text-success-50',
  },
  warning: {
    backgroundStyle: 'bg-caution-10',
    icon: 'report_problem',
    iconColor: 'text-caution-50',
  },
  error: {
    backgroundStyle: 'bg-warning-10',
    icon: 'error',
    iconColor: 'text-warning-50',
  },
  discovery: {
    backgroundStyle: 'bg-purple-10',
    icon: 'auto_awesome',
    iconColor: 'text-purple-50',
  },
} as const satisfies Record<
  'info' | 'success' | 'warning' | 'error' | 'discovery',
  { backgroundStyle: string; icon: RmaIcons; iconColor: string }
>;

export type CalloutType = keyof typeof CALLOUT_CONFIG;
export const DEFAULT_CALLOUT_TYPE: CalloutType = 'error';

export interface CalloutConfig {
  calloutType: CalloutType;
  message: string;
  isHtml?: boolean;
  duration?: number;
  dismissible?: boolean;
}
